import React, { useState }          from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Modal }      from 'react-bootstrap';
import { Formik }                   from 'formik';
import * as yup                     from 'yup';

import ButtonSpinner                from '../../../layout/ButtonSpinner';
import { ICON_CANCEL, ICON_SAVE }   from '../../../extras/icons';
import { saveIntermediatesAction }  from '../../../../actions/intermediatesActions';
import { ErrorMessage }             from '../../../extras/toastMessages';


const IntermediateForm = props => {

    //Tomo los props
    const { audience, handleClose, show } = props;

    //Datos iniciales
    const initialData = {
        fechaInicio: '',
        horaInicio: '',
        fechaFin: '',
        horaFin: '',
        observacion: ''
    }

    //Inicializo el dispatch
    const dispatch = useDispatch();

    //Traigo el store de persona tipos
    const intermediatesLoading = useSelector( state => state.intermediates.loadingSave );
    
    //Inicializo el state local
    const [ intermediate, setNotification ] = useState(initialData);

    //Manejo el guardado
    const handleSave = values => {
        //Agrego los nuevos valores
        const data = {
            activo: 1,
            inicio: `${values.fechaInicio}T${values.horaInicio}:00.000-03:00`,
            fin: `${values.fechaFin}T${values.horaFin}:00.000-03:00`,
            observacion: values.observacion,
            audiencia: {
                id: audience.id
            }
        }
        //Genero los dates para comparar
        const dateInicio = new Date(data.inicio);
        const dateFin = new Date(data.fin);
        //Valido las fechas
        if(dateInicio>=dateFin)
        {   ErrorMessage('La fecha y hora de fin no puede ser menor a la de inicio');
            return false;
        }
        //Es creación
        dispatch( saveIntermediatesAction(data, handleCloseForm) );
    }
    
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setNotification(initialData);
        //Cierro
        handleClose();
    }

    //Esquema de validación
    const validationSchema = yup.object({
        fechaInicio: yup.date().required(),
        horaInicio: yup.string().required(),
        fechaFin: yup.date().required().min(yup.ref('fechaInicio')),
        horaFin: yup.string().required(),
        observacion: yup.string().nullable()
    });

    //Renderizo
    return (
        <Modal  
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleCloseForm } 
            show = { show }
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Intermedio&nbsp;
                    <small><strong>Nuevo Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                initialValues = {{ ...intermediate }}
                onSubmit = { values => handleSave(values) }
                validationSchema = { validationSchema }
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    errors
                }) => (
                    <form autoComplete="off" onSubmit={handleSubmit} noValidate>
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-6">
                                    <label htmlFor="fecha">Fecha inicio</label>
                                    <Form.Control
                                        autoFocus 
                                        className = "form-control"
                                        disabled = { intermediatesLoading }
                                        id = "fechaInicio" 
                                        isInvalid = { !!errors.fechaInicio }
                                        name = "fechaInicio" 
                                        onChange = { handleChange }
                                        type = "date" 
                                        value = { values.fechaInicio }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="horaInicio">Hora inicio</label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { intermediatesLoading }
                                        id = "horaInicio" 
                                        isInvalid = { !!errors.horaInicio }
                                        name = "horaInicio" 
                                        onChange = { handleChange }
                                        type = "time" 
                                        value = { values.horaInicio }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.horaInicio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="fechaFin">Fecha fin</label>
                                    <Form.Control
                                        className = "form-control"
                                        disabled = { intermediatesLoading }
                                        id = "fechaFin" 
                                        isInvalid = { !!errors.fechaFin }
                                        name = "fechaFin"
                                        onChange = { handleChange } 
                                        type = "date" 
                                        value = { values.fechaFin }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fechaFin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="horaFin">Hora fin</label>
                                    <Form.Control
                                        className = "form-control"
                                        disabled = { intermediatesLoading }
                                        id = "horaFin"  
                                        isInvalid = { !!errors.horaFin }
                                        name = "horaFin" 
                                        onChange = { handleChange }
                                        type = "time" 
                                        value = { values.horaFin }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.horaFin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="observacion">Observacion</label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { intermediatesLoading }
                                        id = "observacion"
                                        isInvalid = { !!errors.observacion }
                                        name = "observacion" 
                                        onChange = { handleChange }
                                        type = "observacion" 
                                        value = { values.observacion }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   intermediatesLoading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button 
                                            disabled = { intermediatesLoading }
                                            type = "submit" 
                                            variant = "success" 
                                        >
                                            <ICON_SAVE /> <strong>GUARDAR</strong>
                                        </Button>
                            }
                            <Button 
                                disabled = { intermediatesLoading } 
                                onClick = { handleCloseForm }
                                variant = "secondary" 
                            >
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default IntermediateForm;